export default __webpack_public_path__ + "static/media/white-small.59d6ee5f.png";